import { __extends } from "tslib";
import React, { Component } from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
var ChartSummaryHighcharts = /** @class */ (function (_super) {
    __extends(ChartSummaryHighcharts, _super);
    function ChartSummaryHighcharts() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            chartQuantifier: 'quantity',
            chartOptions: {},
            chartOptionsDesktop: {},
            initialized: false,
        };
        _this.drawChart = function () {
            var data = [];
            for (var key in _this.props.productSortedByCategory[_this.props.selectedCategory]) {
                var subGroup = _this.props.productSortedByCategory[_this.props.selectedCategory][key];
                data.push({ name: subGroup.title, y: +subGroup[_this.state.chartQuantifier].toFixed(2) });
            }
            var ref = _this;
            var chartOptions = {
                chart: {
                    type: 'pie',
                    backgroundColor: '#000',
                    className: 'highchart-container',
                    style: {
                        fontColor: '#fff'
                    }
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    pie: {
                        animation: {
                            duration: 750,
                            easing: 'easeOutQuad'
                        },
                        shadow: false,
                        borderWidth: 0,
                        center: ['50%', '50%'],
                        cursor: 'pointer',
                        showInLegend: true,
                        dataLabels: {
                            enabled: true,
                            // inside: true,
                            align: 'center',
                            distance: -15,
                            crop: false,
                            borderWidth: 0,
                            style: {
                                color: 'white',
                                fontSize: '10px',
                            },
                            formatter: function () {
                                var self = this;
                                if (ref.state.chartQuantifier === 'revenue') {
                                    return self.point.y + ' ' + ref.props.currencyCode;
                                }
                                return self.point.y;
                            }
                        },
                        colors: [
                            '#FF1529',
                            '#FF961B',
                            '#F4CE00',
                            '#7CB43C',
                            '#708739',
                            '#5B3716',
                            '#FF961B',
                            '#8A29EA',
                            '#18D43F',
                            '#FDFD15',
                            '#DDA300',
                            '#1A82DE',
                        ]
                    }
                },
                legend: {
                    align: 'left',
                    layout: 'vertical',
                    verticalAlign: 'top',
                    x: 0,
                    y: 0,
                    margin: 0,
                    itemStyle: {
                        color: '#fff',
                        fontSize: '11px',
                    },
                    itemMarginBottom: 5,
                },
                title: {
                    text: '',
                    style: {
                        color: '#fff'
                    }
                },
                series: [{
                        animation: {
                            duration: 750,
                            easing: 'easeOutQuad'
                        },
                        name: '',
                        size: '100%',
                        // innerSize: '55%',
                        data: data
                    }]
            };
            var chartOptionsDesktop = {
                chart: {
                    type: 'pie',
                    backgroundColor: '#000',
                    className: 'highchart-container',
                    style: {
                        fontColor: '#fff'
                    }
                },
                credits: {
                    enabled: false
                },
                plotOptions: {
                    pie: {
                        animation: {
                            duration: 750,
                            easing: 'easeOutQuad'
                        },
                        shadow: false,
                        borderWidth: 0,
                        center: ['50%', '50%'],
                        cursor: 'pointer',
                        showInLegend: true,
                        dataLabels: {
                            enabled: true,
                            inside: true,
                            softConnector: false,
                            borderWidth: 0,
                            shadow: false,
                            style: {
                                color: '#fff'
                            },
                            formatter: function () {
                                var self = this;
                                if (ref.state.chartQuantifier === 'revenue') {
                                    return self.point.y + ' ' + ref.props.currencyCode;
                                }
                                return self.point.y;
                            }
                        },
                        colors: [
                            '#FF1529',
                            '#FF961B',
                            '#F4CE00',
                            '#7CB43C',
                            '#708739',
                            '#5B3716',
                            '#FF961B',
                            '#8A29EA',
                            '#18D43F',
                            '#FDFD15',
                            '#DDA300',
                            '#1A82DE',
                        ]
                    }
                },
                legend: {
                    align: 'left',
                    layout: 'vertical',
                    verticalAlign: 'top',
                    x: 0,
                    y: 0,
                    itemStyle: {
                        color: '#fff',
                        fontSize: '12px',
                        paddingBottom: '5px',
                    }
                },
                title: {
                    text: '',
                    style: {
                        color: '#fff'
                    }
                },
                series: [{
                        animation: {
                            duration: 750,
                            easing: 'easeOutQuad'
                        },
                        name: '',
                        size: '85%',
                        innerSize: '55%',
                        data: data
                    }]
            };
            _this.setState({
                chartOptions: chartOptions,
                chartOptionsDesktop: chartOptionsDesktop,
                initialized: true
            });
        };
        return _this;
    }
    ChartSummaryHighcharts.prototype.componentDidMount = function () {
        var _this = this;
        if ((!this.state.initialized && this.props.selectedCategory) && Object.keys(this.props.productSortedByCategory).length) {
            setTimeout(function () { return _this.drawChart(); }, 200);
        }
    };
    ChartSummaryHighcharts.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if ((this.props.selectedCategory !== prevProps.selectedCategory)) {
            setTimeout(function () { return _this.drawChart(); }, 200);
        }
        else if (this.props.orderId !== prevProps.orderId) {
            setTimeout(function () { return _this.drawChart(); }, 200);
        }
    };
    ChartSummaryHighcharts.prototype.toggleQuantitfier = function () {
        var _this = this;
        var chartQuantifier = this.state.chartQuantifier === 'quantity' ? 'revenue' : 'quantity';
        this.setState({ chartQuantifier: chartQuantifier }, function () {
            _this.drawChart();
        });
    };
    ChartSummaryHighcharts.prototype.render = function () {
        var _this = this;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "mobile-only", style: { width: '100%', height: '100%' } },
                React.createElement(HighchartsReact, { highcharts: Highcharts, options: this.state.chartOptions, className: 'dkjsdekjs' })),
            React.createElement("div", { className: "desktop-only", style: { width: '100%', height: '100%' } },
                React.createElement(HighchartsReact, { highcharts: Highcharts, options: this.state.chartOptionsDesktop, className: 'dkjsdekjs' })),
            React.createElement("div", { className: "dashboard-chart__toggler" },
                React.createElement("div", { className: "a-form-control a-form-control-toggle" },
                    React.createElement("div", { className: "a-form-control-toggle__option a-form-control-toggle__option--left" }, "Quantity"),
                    React.createElement("div", { className: "a-form-control-toggle__control" },
                        React.createElement("input", { type: "checkbox", checked: this.state.chartQuantifier === 'revenue', className: "a-form-control-toggle__checkbox", onChange: function () { return _this.toggleQuantitfier(); } }),
                        React.createElement("label", { className: "a-form-control-toggle__knob" })),
                    React.createElement("div", { className: "a-form-control-toggle__option a-form-control-toggle__option--right" }, "Amount")))));
    };
    return ChartSummaryHighcharts;
}(Component));
export { ChartSummaryHighcharts };
export default ChartSummaryHighcharts;
//# sourceMappingURL=ChartSummaryHighcharts.js.map